import { Injectable } from '@angular/core';

@Injectable()
export class TokenUtilsService {
  private readonly GUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  isGuid(token: string): boolean {
    return this.GUID_REGEX.test(token);
  }

  isFulfillerToken(token: string): boolean {
    if (!token || token === 'undefined' || token === 'null') return false;

    if (!token.startsWith('fulfiller ')) return false;

    return this.isGuid(token.replace('fulfiller ', '').trim());
  }

  validateTokenOrThrow(token: string): void {
    if (!this.isGuid(token)) {
      throw new Error('Authorization token is not available. User may not be logged.');
    }
  }
}

